import { render, staticRenderFns } from "./hangUpMonitoring.vue?vue&type=template&id=2b79fd02&scoped=true"
import script from "./hangUpMonitoring.vue?vue&type=script&lang=js"
export * from "./hangUpMonitoring.vue?vue&type=script&lang=js"
import style0 from "./hangUpMonitoring.vue?vue&type=style&index=0&id=2b79fd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79fd02",
  null
  
)

export default component.exports